import React, { Component } from 'react'
import withStyles from '@mui/styles/withStyles';
import clsx from "clsx";
import { CloudUpload } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';
import UploadFiles from '../Pages/Dossiers/Common/UploadFiles';
import { flushSync } from 'react-dom';

const styles = theme => ({
    dropzone: {
        height: 0,
        width: '100%',
        padding: '50% 0',
        backgroundColor: '#fff',
        border: '2px dashed rgb(187, 186, 186)',
        borderRadius: 5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        fontSize: 16,
        '&.highlight': {
            backgroundColor: 'rgb(188, 185, 236)'
        }
    },
    icon: {
        opacity: 0.3,
        height: 64,
        width: 64
    },
    fileInput: {
        display: 'none'
    }
});


class Dropzone extends Component {
    constructor(props) {
        super(props)
        this.state = { hightlight: false, isUploadFilesDialogOpen: false }
        this.fileInputRef = React.createRef()

        this.openFileDialog = this.openFileDialog.bind(this)
        this.onFilesAdded = this.onFilesAdded.bind(this)
        this.onDragOver = this.onDragOver.bind(this)
        this.onDragLeave = this.onDragLeave.bind(this)
        this.onDrop = this.onDrop.bind(this)
    }

    openFileDialog(e) {
        if (this.props.disabled) return
        if (this.props.openCamera) {
            this.props.openCamera();
            return;
        } else {
            if (this.props.withUploadFileDialog) {
                flushSync(()=>{this.setState({ isUploadFilesDialogOpen: true })})
                return false;
            }
            this.fileInputRef.current.click()
        }
    }

    onFilesAdded(evt) {
        if (this.props.disabled) return
        const files = evt.target.files
        if (this.props.onFilesAdded) {
            const array = this.fileListToArray(files)
            this.props.onFilesAdded(array)
        }
        evt.target.value = "";
    }

    onDragOver(evt) {
        evt.preventDefault()

        if (this.props.disabled) return

        flushSync(()=>{this.setState({ hightlight: true })})
    }

    onDragLeave() {
        flushSync(()=>{this.setState({ hightlight: false })})
    }

    onDrop(event) {
        event.preventDefault()
        if (this.props.disabled) return
        const files = event.dataTransfer.files
        if (this.props.onFilesAdded) {
            const array = this.fileListToArray(files)
            this.props.onFilesAdded(array)
        }
        flushSync(()=>{this.setState({ hightlight: false })})
    }

    fileListToArray(list) {
        const array = []
        for (var i = 0; i < list.length; i++) {
            array.push(list.item(i))
        }
        return array
    }

    handleUploadFilesDialogClose = (e) => {
        flushSync(()=>{this.setState({ isUploadFilesDialogOpen: false })})
        return false;
    }

    render() {
        const { hideExistingImageModal, multiple=true,projectId,buildingId,title = '',isAssignmentFile, isFundering,redirectRepairRequestHandler, isHideLocatie, classes, iconClasses = {}, className = {}, uploading, handleSelectExistingImages, handlePreviewOfFiles } = this.props;
        return (
            <React.Fragment>
                {this.props.withUploadFileDialog && <UploadFiles
                    isFundering={isFundering}
                    hideExistingImageModal={hideExistingImageModal}
                    isAssignmentFile={isAssignmentFile}
                    canDrawingDossier={this.props.canDrawingDossier}
                    existingImageModal={this.props.existingImageModal}
                    selectedDossier={this.props.selectedObjects}
                    handlePreviewOfFiles={handlePreviewOfFiles}
                    handleSelectExistingImages={(data) => {
                        handleSelectExistingImages(data);
                        flushSync(()=>{this.setState({ isUploadFilesDialogOpen: false })})
                    }}
                    redirectRepairRequestHandler={redirectRepairRequestHandler}
                    buildings={this.props.buildings}
                    handleSubmit={(f) => this.props.onFilesAdded(f)}
                    open={this.state.isUploadFilesDialogOpen}
                    onClose={this.handleUploadFilesDialogClose}
                    accept={this.props.accept || '*'}
                    isSurveying={this.props.isSurveying}
                    isHideLocatie={isHideLocatie}
                    title={title} />}
                <div
                    className={this.state.hightlight ? clsx(classes.dropzone, 'highlight', className) : clsx(classes.dropzone, className)}
                    onDragOver={this.onDragOver}
                    onDragLeave={this.onDragLeave}
                    onDrop={this.onDrop}
                    onClick={this.openFileDialog}
                    style={{ cursor: this.props.disabled ? 'default' : 'pointer' }}
                >
                    <input
                        ref={this.fileInputRef}
                        className={classes.fileInput}
                        type="file"
                        accept={this.props.accept ? this.props.accept : "*"}
                        multiple={multiple}
                        onChange={this.onFilesAdded}
                    />
                    {
                        uploading === true ?
                            <CircularProgress className={classes.icon} />
                            :
                            <CloudUpload className={clsx(classes.icon, iconClasses)} />
                    }
                </div>
            </React.Fragment>
        )
    }
}

export default withStyles(styles)(Dropzone)
